<template>
  <section class="module-2-boxes container">
    <div class="container">
      <div class="columns is-multiline">
        <div class="module-boxes">
          <div class="container">
            <div class="columns block-box">
              <div class="column is-6-desktop is-6-tablet is-12-mobile">
                <Skeletor class="mb-box" width="100%" height="680" />
              </div>
              <div class="column is-6-desktop is-6-tablet is-12-mobile">
                <Skeletor class="mb-box" width="100%" height="680" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss"></style>
